(() => {
  if (customElements.get('complementary-products')) {
    return;
  }

  class ComplementaryProducts extends customElements.get(
    'card-product-slider'
  ) {
    constructor() {
      super();

      const swiperOptions = JSON.parse(this.getAttribute('data-swiper-options')) || {};

      this.sliderOptions = {
        slidesPerView: swiperOptions.slidesPerViewMobile || 1,
        spaceBetween: swiperOptions.spaceBetweenMobile || 2,
        // Lock the slider when all cards fit, kill elastic edge over-drag, and
        // recalc bounds on size changes so you can't drag past the last card
        // into empty space.
        watchOverflow: true,
        resistanceRatio: 0,
        observer: true,
        observeParents: true,
        breakpoints: {
          990: {
            spaceBetween: swiperOptions.spaceBetweenDesktop || 2,
            slidesPerView: swiperOptions.slidesPerViewDesktop || 2,
            slidesPerGroup: 2
          }
        }
      };
    }

    initSlider() {
      // Reveal BEFORE initializing Swiper so it measures the real container width.
      // Initializing while the wrapper is still display:none gives Swiper a 0-width
      // container, so its scroll bounds are wrong and you can drag past the last
      // card into empty space.
      this.parentElement.classList.remove('hidden');

      // Reveal the entire section wrapper now that we have products
      var sectionWrapper = this.closest('[data-cts-section]');
      if (sectionWrapper) sectionWrapper.classList.remove('hidden');

      // Reveal compact wrapper if in compact mode
      var compactWrap = document.querySelector('.cts-compact-inline');
      if (compactWrap) compactWrap.style.display = '';

      super.initSlider();

      // Recalculate now that everything is visible (belt & suspenders).
      if (this.slider) {
        var s = this.slider;
        requestAnimationFrame(function () { try { s.update(); } catch (e) {} });
      }

      if (document.querySelector("quick-cart-drawer")) {
        document.querySelector("quick-cart-drawer").init();
      }

      if (Shopify.designMode) {
        if (document.querySelector("quick-cart-drawer")) {
          document.querySelector("quick-cart-drawer").init();
        }
      }
    }
  }

  customElements.define(
    'complementary-products',
    ComplementaryProducts
  );
})();
